<div class="h-full w-full p-3 overflow-y-scroll">
  <app-breadcrumb [items]="[{ label: 'Organizations' }]"/>

  <div class="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">

    <div class="mb-6 flex items-center justify-between">
      <div>
        <h4 class="text-xl font-semibold text-black dark:text-white">
          Organizations
        </h4>

        <p class="mt-1 text-sm text-bodydark2">
          Select an organization to use globally across the application.
        </p>
      </div>
    </div>

    @if (organizationChangeError()) {
    <p class="mb-4 rounded-lg border border-red-200 bg-red-100 p-3 text-sm text-red-600">{{ organizationChangeError() }}</p>
    }

    <div class="max-w-full overflow-x-auto">
      <table class="w-full table-auto">
        <thead>
          <tr class="bg-gray-2 text-left dark:bg-meta-4">
            <th class="min-w-55 py-4 px-4 font-medium text-black dark:text-white xl:pl-11">
              Organization
            </th>
            <th class="min-w-37.5 py-4 px-4 font-medium text-black dark:text-white">
              ID
            </th>
            <th class="min-w-30 py-4 px-4 font-medium text-black dark:text-white">
              Status
            </th>
            <th class="py-4 px-4 font-medium text-black dark:text-white">
              Action
            </th>
          </tr>
        </thead>

        <tbody>
        @for (org of organizationStore.organizations(); track org.id) {
          <tr class="border-b border-[#eee] dark:border-strokedark" [ngClass]="{'bg-blue-100': org.id == organizationStore.selectedOrganizationId()}">
            <td class="py-5 px-4 pl-9 xl:pl-11">
              <div class="flex items-center gap-4">
                <div>
                  <h5 class="font-medium text-black dark:text-white">
                    {{ org.name }}
                  </h5>
                </div>

              </div>
            </td>

            <td class="py-5 px-4">
              <div class="flex items-center gap-2">
                <button type="button" (click)="copyToClipboard(org.id)"
                  class="group relative font-mono text-sm text-gray-600 hover:text-gray-800 dark:hover:text-gray-200 transition-colors" [title]="org.id">
                  @if (copiedText() === org.id) {
                    <span class="flex items-center gap-1.5 text-green-500">
                      <svg class="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      Copied!
                    </span>
                  } @else {
                    <svg class="absolute -left-4 top-1/2 -translate-y-1/2 h-3.5 w-3.5 opacity-0 group-hover:opacity-100 transition-opacity" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>
                    </svg>
                    <span class="inline-block truncate">{{ org.id }}</span>
                  }
                </button>
              </div>
            </td>

            <!-- Status -->
            <td class="py-5 px-4">
              <p class="inline-flex rounded-full bg-success bg-opacity-10 py-1 px-3 text-sm font-medium text-white">
                Active
              </p>
            </td>

            <!-- Action -->
            <td class="py-5 px-4">
              <button (click)="selectOrganization(org)" [disabled]="!!changingOrganizationId()"
                class="flex items-center gap-2 rounded-lg bg-primary py-2 px-4 text-white hover:bg-opacity-90 disabled:cursor-not-allowed disabled:opacity-50">
                @if (changingOrganizationId() === org.id) {
                <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/></svg>
                Selecting...
                } @else {
                Select
                }
              </button>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="4" class="py-8 text-center text-bodydark2">
              No organizations found.
            </td>
          </tr>
        }
        </tbody>
      </table>
    </div>
  </div>
</div>